export const SEND_INVOICES_TITLE: string = 'Send Invoices';
export const SEND_INVOICES_SUBMIT_TEXT: string = 'send';
export const GET_INVOICES_SUBMIT_TEXT: string = 'Get Invoices List';
export const GET_DRAFT_INVOICES_MONTH_PLACEHOLDER: string = 'Enter invoices month';
export const GET_DRAFT_INVOICES_YEAR_PLACEHOLDER: string = 'Enter invoices year';
export const SENT_SUCCESSFULLY: string = 'Invoices sent successfully';
export const CONFIRM_SEND = (invoicesMonth: number, invoicesYear: number) => {
  return `Are you sure to send all selected draft invoices from easybill for\
  ${invoicesMonth}-${invoicesYear} to the dealers?`;
};
